import type {
  CSSProperties,
  ElementType,
  HTMLAttributes,
  ReactNode,
} from "react";
import "./LayoutPrimitives.scss";

type StackProps = HTMLAttributes<HTMLElement> & {
  align?: CSSProperties["alignItems"];
  as?: ElementType;
  children?: ReactNode;
  gap?: CSSProperties["gap"];
};

export function Stack({
  align,
  as: Component = "div",
  children,
  className = "",
  gap,
  style,
  ...props
}: StackProps) {
  return (
    <Component
      className={`layout-stack ${className}`.trim()}
      style={{
        ...style,
        ...(align === undefined ? {} : { alignItems: align }),
        ...(gap === undefined ? {} : { gap }),
      }}
      {...props}
    >
      {children}
    </Component>
  );
}
